import React from 'react';
import "./BadgeNotification.css";

interface ShoppingBagBadgeProps{
    amount : number;
}

const ShoppingBagBadge:React.FC<ShoppingBagBadgeProps> = (props) => {
    if(props.amount > 0){
        return (
            <span className="badge-notifications">{props.amount}</span>
          )
    } else {
        return (
            <span className="badge-notifications">{""}</span>
          )
    }
}

export default ShoppingBagBadge